export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-array/src/number.js
// module id = 26
// module chunks = 0 1 2 3 4